import { render, staticRenderFns } from "./reviewVideoReplay.vue?vue&type=template&id=644f874e&scoped=true"
import script from "./reviewVideoReplay.vue?vue&type=script&lang=js"
export * from "./reviewVideoReplay.vue?vue&type=script&lang=js"
import style0 from "./reviewVideoReplay.vue?vue&type=style&index=0&id=644f874e&prod&lang=scss&scoped=true"
import style1 from "./reviewVideoReplay.vue?vue&type=style&index=1&id=644f874e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f874e",
  null
  
)

export default component.exports